<template>
  <el-dialog
    title="Insert campaign"
    :visible="dialog_form"
    :close-on-click-modal="false"
    width="500px"
    top="3vh"
    :modal="true"
    custom-class="campaignModal"
    @close="closeModal"
    @open="openModal"
  >
    <el-form ref="track" :model="track" label-position="top">
      <el-form-item label="Campaign Name" prop="name">
        <el-input type="text" v-model="track.name" clearable />
      </el-form-item>
      <el-form-item label="Track" prop="artist">
        <el-select v-model="track.id" clearable filterable>
          <el-option
            v-for="t in track_list"
            :key="t.id"
            :value="t.id"
            :label="`${t.artist[0].name} - ${t.title}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Daterange" prop="daterange">
        <el-date-picker
          v-model="track.date_range"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="dateRangeOptions"
          format="d MMMM yyyy"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item  prop="user_tier">
        <el-checkbox label="Bronze Tier Timeout" v-model="track.silver_tier"></el-checkbox>
      </el-form-item>
      <el-form-item label="Days" prop="days" v-if="track.silver_tier">
        <el-input-number v-model="track.days"  :min="0" :precision="0" clearable />
      </el-form-item>
      <el-form-item label="Campaign Package" prop="campaign_package">
        <el-select v-model="track.campaign_packages_id" clearable filterable>
          <el-option
              v-for="c in campaign_packages"
              :key="c.id"
              :value="c.id"
              :label="`${c.name}`"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Bands" prop="bands">
        <el-checkbox-group v-model="bands" class="bands-group">
          <el-checkbox-button label="A" >A</el-checkbox-button>
          <el-checkbox-button label="B" >B</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <div v-if="track.campaign_packages_id === 2">
        <el-form-item label="YouTube Category">
          <el-select v-model="track.youtube_categories" multiple collapse-tags
                     placeholder="Select category" :multiple-limit="5" filterable>
            <el-option v-for="category in youtubeCategories" :key="category.id"
                       :label="category.name" :value="category.id">
            </el-option>
          </el-select>
        </el-form-item>
        <label class="subscriber-reach">
          Subscriber Reach
          <el-button v-if="track.subscriberReach" @click="track.subscriberReach = null"
                     icon="el-icon-refresh" circle class="refresh-btn"></el-button>
        </label>
        <el-radio v-for="(option, i) in subscriberOptions" :key="option"
                  v-model="track.subscriberReach" :label="option">
          {{ i === subscriberOptions.length - 1 ? option + '+'  : option }}K
        </el-radio>
        <div class="mb10"></div>
        <el-form-item label="Categories and Subscribers - days">
          <el-date-picker v-model="track.youtubeCategoryDays" type="date" placeholder="Select date"
                          :picker-options="pickerOptions" :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">
          </el-date-picker>
        </el-form-item>
      </div>
      <el-form-item label="Balance" prop="balance">
        <el-input-number :min="1" :precision="0" v-model="track.balance" clearable />
      </el-form-item>
      <div class="mt10">
        <el-radio v-model="track.bonusType" label="standard"> TopUp </el-radio>
        <el-radio v-model="track.bonusType" label="bonus"> Bonus </el-radio>
      </div>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="mini" @click="callCreateTrack">
        Save
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      subscriberOptions: ['0-10', '10-50', '50-100', '100-200', '200'],
      bands: []
    }
  },
  computed: {
    ...mapState('vcTrack', ['track', 'track_list', 'dialog_form', 'campaign_packages', 'youtubeCategories']),
    pickerOptions() {
      const vm = this
      return {
        disabledDate(time) {
          const today = new Date();

          const campaignEnd = vm.track.date_range && vm.track.date_range.length === 2
              ? time.getTime() >= new Date(vm.track.date_range[1]).getTime()
              : false

          return campaignEnd || time.getTime() < today.setDate(today.getDate() - 1)
        }
      }
    }
  },

  methods: {
    ...mapActions('vcTrack', ['createTrack', 'readTrackList', 'readCampaignPackages']),
    ...mapMutations('vcTrack', ['setTrackForm', 'setTrack']),
    openModal() {
      this.readTrackList()
      this.readCampaignPackages()
      this.track.balance =  0;
      this.track.days =  0;
      this.track.vc_rate = 10;
      this.track.bands = 0
      this.bands = []
    },
    closeModal(){
      this.setTrack({})
      this.setTrackForm(false)
    },
    callCreateTrack(){
      if(this.bands.includes('A') && this.bands.includes('B')){
        this.track.bands = 3;
      }
      else if(this.bands.includes('A')){
        this.track.bands = 1;
      }
      else if(this.bands.includes('B')){
        this.track.bands = 2;
      }
      else{
        this.track.bands = 0;
      }
      if((this.track.bands == 1 ||this.track.bands == 3)  && this.track.balance < 500){
        this.$msgbox('Minimum budget for this campaign is $500', 'Error')
      }
      else if(this.track.bands == 2 && this.track.balance < 250){
        this.$msgbox('Minimum budget for this campaign is $250', 'Error')
      }
      else{
        this.createTrack()
      }
    }
  },


}
</script>
<style lang="css" scope>
.el-select{
  width: 100%;
}
.bands-group{
  display: inline-flex;
}
</style>
